import React, { useState, useMemo } from "react";
import { Search, Plus, MessageCircle } from "lucide-react";
import ThreadListItem from "../molecules/ThreadListItem";
import ThreadListItemSkeleton from "../molecules/ThreadListItemSkeleton";
import { INK, INK_3, LINE, BURGUNDY, BURGUNDY_TINT } from "../../Bureau/bureauTokens";
import { normalizeText } from "../../../utils/text.js";

function ThreadList({ conversations, usersById, selectedId, onSelect, onNewConversation, loading }) {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    if (!q.trim()) return conversations;
    const needle = normalizeText(q);
    return conversations.filter((c) => {
      const u = usersById[c.otherUserId];
      const name = u ? `${u.name || ""} ${u.lastName || ""}` : "";
      return normalizeText(name).includes(needle);
    });
  }, [conversations, usersById, q]);

  return (
    <div
      className="flex flex-col min-h-0 h-full"
      style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
    >
      <div className="flex items-center gap-2 p-3" style={{ borderBottom: `1px solid ${LINE}` }}>
        <div className="relative flex-1">
          <Search size={13} className="absolute top-1/2 -translate-y-1/2 left-2.5" style={{ color: INK_3 }} />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Rechercher un collaborateur…"
            className="w-full h-8 pl-7 pr-2.5 text-xs outline-none"
            style={{ border: `1px solid ${LINE}`, borderRadius: 8 }}
          />
        </div>
        <button
          onClick={onNewConversation}
          title="Nouveau message"
          className="flex-shrink-0 flex items-center justify-center text-white"
          style={{ width: 32, height: 32, borderRadius: 8, background: BURGUNDY }}
        >
          <Plus size={15} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-1.5">
        {loading && filtered.length === 0
          ? Array.from({ length: 6 }).map((_, i) => <ThreadListItemSkeleton key={`sk-${i}`} />)
          : filtered.map((c) => (
              <ThreadListItem
                key={c.id}
                otherUser={usersById[c.otherUserId]}
                lastMessage={c.lastMessage}
                unreadCount={c.unreadCount}
                updatedAt={c.updatedAt}
                active={c.id === selectedId}
                onClick={() => onSelect(c.id)}
              />
            ))}
        {!loading && filtered.length === 0 && q.trim() && (
          <div className="flex flex-col items-center gap-2 text-center py-16 text-xs" style={{ color: INK_3 }}>
            <Search size={18} />
            Aucun collaborateur ne correspond à « {q.trim()} »
          </div>
        )}
        {!loading && filtered.length === 0 && !q.trim() && (
          <div className="flex flex-col items-center gap-3 text-center px-6 py-16">
            <span
              className="flex items-center justify-center flex-shrink-0"
              style={{ width: 52, height: 52, borderRadius: "50%", background: BURGUNDY_TINT, color: BURGUNDY }}
            >
              <MessageCircle size={22} />
            </span>
            <div>
              <p className="text-[12.5px] font-semibold" style={{ color: INK }}>
                Aucune conversation pour l'instant
              </p>
              <p className="text-[11px] mt-1" style={{ color: INK_3 }}>
                Démarrez une discussion avec un collègue.
              </p>
            </div>
            <button
              onClick={onNewConversation}
              className="flex items-center gap-1.5 px-3.5 py-2 text-[11.5px] font-semibold text-white"
              style={{ background: BURGUNDY, borderRadius: 10 }}
            >
              <Plus size={13} /> Nouveau message
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ThreadList;
